import config from 'config'
import { selectSkipRefetchStores } from 'data/selectors'
import { getRequestParams } from 'data/utils'
import * as dateMenuSelectors from 'menu/DateMenu/selectors'
import { createLogic } from 'redux-logic'
import type { State } from 'store/types'
import type { NetworkError } from 'utils'
import { fetchAction } from 'utils'

import * as constants from './constants'

const fetchStores = createLogic<State, {}>({
  type: constants.FETCH_STORES,
  latest: true,

  async process({ action, getState }, dispatch, done) {
    try {
      const state = getState()
      const baseRequestParams = dateMenuSelectors.baseRequestParams(state, action as any)
      const skipRefetch = selectSkipRefetchStores(action.payload)(state)

      if (skipRefetch) {
        dispatch({
          type: constants.FETCH_STORES_DONE,
          payload: action.payload,
        })
      } else {
        const response = await fetchAction(config.api.stores, {
          ...getRequestParams(action as any), // ecoms, necoms, channel, countryId, etc.
          ...baseRequestParams, // dateCurrent, dateCompared, range
        })

        dispatch({
          type: constants.FETCH_STORES_SUCCESS,
          payload: {
            ...action.payload,
            data: response.data,
          },
        })
      }
    } catch (error) {
      dispatch({
        type: constants.FETCH_STORES_ERROR,
        payload: {
          ...action.payload,
          errorCode: (error as NetworkError)?.response?.status || -1,
        },
      })
    }
    done()
  },
})

export default [fetchStores]
